// extracted by mini-css-extract-plugin
export default {"container":"LoadingFile_container__rfAcx"};